import React from 'react';
import ReactDOM from 'react-dom/client';
import "bootstrap/dist/css/bootstrap.min.css";
import './index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import LandingPageAdmin from './dashboard/admin/LandingPageAdmin';
import "bootstrap/dist/js/bootstrap.bundle.js";
import CustomerPage from './dashboard/admin/CustomerPage';
import ProductsPage from './dashboard/admin/ProductsPage';
import CategoryPage from './dashboard/admin/CategoryPage';
import EditProductPage from './dashboard/admin/EditProductPage';
import EditCategoryPage from './dashboard/admin/EditCategoryPage';
import BrandsPage from './dashboard/admin/BrandsPage';
import EditBrandPage from './dashboard/admin/EditBrandPage';
import OffersPage from './dashboard/admin/OffersPage';
import EditOfferPage from './dashboard/admin/EditOfferPage';
import AdminHomePage from './dashboard/admin/AdminHomePage';
import AdminLoginPage from './dashboard/admin/AdminLoginPage';
import PrivateRoute from './dashboard/admin/navigation/PrivateRoute';
import SettingsPage from './dashboard/admin/SettingsPage';
import LandingPageUser from './dashboard/user/LandingPageUser';
import LandingPage from './dashboard/LandingPage';
import HomePage from './dashboard/user/HomePage';
import ProductPage from './dashboard/user/ProductPage';
import CategoryListPage from './dashboard/user/CategoryListPage';
import ProductsByCat from './dashboard/user/ProductsByCat';
import CartPage from './dashboard/user/CartPage';
import { Provider } from 'react-redux';
import store from './dashboard/redux/reduxStore';
// import { persistor } from './dashboard/redux/reduxStore';
// import { PersistGate } from 'redux-persist/integration/react';
import NewAddressPage from './dashboard/user/NewAddressPage';
import ConfirmOrderPage from './dashboard/user/ConfirmOrderPage';
import MyOrdersPage from './dashboard/user/MyOrdersPage';
import OrderDetailsPage from './dashboard/user/OrderDetailsPage';
import OrdersPage from './dashboard/admin/OrdersPage';
import AdminOrderDetailsPage from './dashboard/admin/AdminOrderDetailsPage';
import AllOrdersPage from './dashboard/admin/AllOrdersPage';
import SearchPage from './dashboard/user/SearchPage';
import BrandsListPage from './dashboard/user/BrandsListPage';
import ProdByBrand from './dashboard/user/ProdByBrand';
import UserProfilePage from './dashboard/user/UserProfilePage';
import UserLoginPage from './dashboard/user/UserLoginPage';
import AboutUsPage from './dashboard/user/AboutUsPage';
import ContactUsPage from './dashboard/user/ContactUsPage';
import PendingOrdersPage from './dashboard/admin/PendingOrdersPage';
import ConfirmedOrderPage from './dashboard/admin/ConfirmedOrderPage';
import ShippedOrdersPage from './dashboard/admin/ShippedOrdersPage';
import DeliveredOrdersPage from './dashboard/admin/DeliveredOrdersPage';
import CancelledOrdersPage from './dashboard/admin/CancelledOrdersPage';
import FeaturedProductsPage from './dashboard/admin/FeaturedProductsPage';
import AdminReportPage from './dashboard/admin/AdminReportPage';
import AllNotificationsPage from './dashboard/admin/AllNotificationsPage';
import PrivacyPolicyPage from './dashboard/user/PrivacyPolicyPage';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      {/* <PersistGate loading={null} persistor={persistor}> */}
        <BrowserRouter>
          <Routes>
            <Route path='/' element={<LandingPage />}>
              <Route path='' element={<HomePage />} />
              <Route path='/product/:id' element={<ProductPage />} />
              <Route path='/categories' element={<CategoryListPage />} />
              <Route path='/products-by-cat/:category' element={<ProductsByCat />} />
              <Route path='/mycart' element={<CartPage />} />
              <Route path='/add-address' element={<NewAddressPage />} />
              <Route path='/place-order' element={<ConfirmOrderPage />} />
              <Route path='/my-orders' element={<MyOrdersPage />} />
              <Route path='/order-details/:id' element={<OrderDetailsPage />} />
              <Route path='/search' element={<SearchPage />} />
              <Route path='/brand-list' element={<BrandsListPage />} />
              <Route path='/products-by-brand/:brand' element={<ProdByBrand />} />
              <Route path='/my-profile' element={<UserProfilePage />} />
              <Route path='/user-login' element={<UserLoginPage />} />
              <Route path='/about-us' element={<AboutUsPage />} />
              <Route path='/contact-us' element={<ContactUsPage />} />
            </Route>
            <Route path='/admin-login' element={<AdminLoginPage />} />
            <Route path='/admin' element={<PrivateRoute><LandingPageAdmin /></PrivateRoute>}>
              <Route path='' element={<AdminHomePage />} />
              <Route path='/admin/products' element={<ProductsPage />} />
              <Route path='/admin/products/edit/:productId' element={<EditProductPage />} />
              <Route path='/admin/categories' element={<CategoryPage />} />
              <Route path='/admin/categories/edit/:id' element={<EditCategoryPage />} />
              <Route path='/admin/users' element={<CustomerPage />} />
              <Route path='/admin/brands' element={<BrandsPage />} />
              <Route path='/admin/brands/edit/:id' element={<EditBrandPage />} />
              <Route path='/admin/offers' element={<OffersPage />} />
              <Route path='/admin/offers/edit/:id' element={<EditOfferPage />} />
              <Route path='/admin/settings' element={<SettingsPage />} />
              <Route path='/admin/orders' element={<OrdersPage />} />
              <Route path='/admin/orders-details/:id' element={<AdminOrderDetailsPage />} />
              <Route path='/admin/all-orders' element={<AllOrdersPage />} />
              <Route path='/admin/pending-orders' element={<PendingOrdersPage />} />
              <Route path='/admin/confirmed-orders' element={<ConfirmedOrderPage />} />
              <Route path='/admin/shipped-orders' element={<ShippedOrdersPage />} />
              <Route path='/admin/delivered-orders' element={<DeliveredOrdersPage />} />
              <Route path='/admin/cancelled-orders' element={<CancelledOrdersPage />} />
              <Route path='/admin/featured-products' element={<FeaturedProductsPage/>} />
              <Route path='/admin/admin-report' element={<AdminReportPage/>} />
              <Route path='/admin/notifications' element={<AllNotificationsPage />} />
            </Route>
            <Route path='/privacy-policy' element={<PrivacyPolicyPage />} />
          </Routes>
        </BrowserRouter>
      {/* </PersistGate> */}
    </Provider>
  </React.StrictMode >
);


reportWebVitals();
